export default __webpack_public_path__ + "file/Fiche-EN-Produit-Puroak-Stave-24.asset.7be42dc8.pdf";